import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { API, fetchProductImages } from "@/lib/api";

// Owner-uploaded product photos (managed from /admin → Product Images).
// Storefront tiles prefer the owner's photo over the bundled placeholder.
const ProductImagesContext = createContext({ images: {}, refresh: () => {} });

export const ProductImagesProvider = ({ children }) => {
  const [images, setImages] = useState({});
  const refresh = useCallback(async () => {
    try {
      setImages(await fetchProductImages());
    } catch {
      /* keep bundled placeholder images */
    }
  }, []);
  useEffect(() => {
    refresh();
  }, [refresh]);
  return (
    <ProductImagesContext.Provider value={{ images, refresh }}>
      {children}
    </ProductImagesContext.Provider>
  );
};

export const useProductImages = () => useContext(ProductImagesContext);

export const productImageUrl = (images, slug, fallback) =>
  images[slug] ? `${API}/files/${images[slug]}` : fallback;
